import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "workpackage-selector" },
    [
      _c(VAutocomplete, {
        attrs: {
          items: _vm.wpItems,
          "item-text": "text",
          "item-value": "value",
          multiple: "",
          chips: "",
          "small-chips": "",
          "deletable-chips": "",
          loading: _vm.loadingWp,
          counter: _vm.maxSelections,
          label: _vm.$t("general.labels.selectDefault"),
          "search-input": _vm.search,
          "item-disabled": _vm.isItemDisabled,
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.search = $event
          },
          "update:search-input": function ($event) {
            _vm.search = $event
          },
          blur: _vm.onBlur,
          change: _vm.onChange,
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function ({ item, index }) {
              return [
                index < 5
                  ? _c(
                      VChip,
                      {
                        attrs: { close: "" },
                        on: {
                          "click:close": function ($event) {
                            return _vm.deselect(item.value)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.text))]
                    )
                  : index === 5
                  ? _c("span", [
                      _vm._v("+" + _vm._s(_vm.selectedIds.length - 5)),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selectedIds,
          callback: function ($$v) {
            _vm.selectedIds = $$v
          },
          expression: "selectedIds",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }